


import React from "react";

const featuredCars = [
  // {
  //   id: 1,
  //   image: "/images/fleet/Honda-Amaze.jpg",
  //   title: "Honda Amaze",
  //   category: "Sedan",
  //   seats: "4+1 Seats",
  //   fuel: "Petrol / CNG",
  //   price: "₹12/KM",
  // },
  // {
  //   id: 2,
  //   image: "/images/fleet/Hyundai-Aura.jpg",
  //   title: "Hyundai Aura",
  //   category: "Sedan",
  //   seats: "4+1 Seats",
  //   fuel: "Petrol / CNG",
  //   price: "₹12/KM",
  // },
  // {
  //   id: 3,
  //   image: "/images/fleet/Hyundai-Xcent.jpg",
  //   title: "Hyundai Xcent",
  //   category: "Sedan",
  //   seats: "4+1 Seats",
  //   fuel: "Petrol",
  //   price: "₹12/KM",
  // },
  {
    id: 10,
    image: "/images/fleet/Toyota-Corolla-Altis.jpg",
    title: "Toyota Corolla Altis",
    category: "Luxury Sedan",
    seats: "4+1 Seats",
    fuel: "Petrol",
    price: "₹15/KM",
  },

  {
    id: 4,
    image: "/images/fleet/Innova-Crysta.jpg",
    title: "Toyota Innova Crysta",
    category: "Premium SUV",
    seats: "6+1 Seats",
    fuel: "Diesel",
    price: "₹18/KM",
  },
  {
    id: 5,
    image: "/images/fleet/Kia-Carens.jpg",
    title: "Kia Carens",
    category: "MUV",
    seats: "6+1 Seats",
    fuel: "Diesel",
    price: "₹16/KM",
  },
  {
    id: 6,
    image: "/images/fleet/Maruti-Ertiga.jpg",
    title: "Maruti Ertiga",
    category: "SUV",
    seats: "6+1 Seats",
    fuel: "Petrol / CNG",
    price: "₹14/KM",
  },
  // {
  //   id: 7,
  //   image: "/images/fleet/Mini-Bus.jpg",
  //   title: "Mini Bus",
  //   category: "Bus",
  //   seats: "25-32 Seats",
  //   fuel: "Diesel",
  //   price: "On Request",
  // },
  // {
  //   id: 8,
  //   image: "/images/fleet/Swift-Dzire.jpg",
  //   title: "Swift Dzire",
  //   category: "Sedan",
  //   seats: "4+1 Seats",
  //   fuel: "Petrol / CNG",
  //   price: "₹12/KM",
  // },
  {
    id: 9,
    image: "/images/fleet/Tourist-Special-Innova.jpg",
    title: "Tourist Special Innova",
    category: "SUV",
    seats: "6+1 Seats",
    fuel: "Diesel",
    price: "₹17/KM",
  },

  // {
  //   id: 11,
  //   image: "/images/fleet/Toyota-Etios.jpg",
  //   title: "Toyota Etios",
  //   category: "Sedan",
  //   seats: "4+1 Seats",
  //   fuel: "Petrol",
  //   price: "₹12/KM",
  // },
  // {
  //   id: 12,
  //   image: "/images/fleet/Scorpio.jpg",
  //   title: "Mahindra Scorpio",
  //   category: "SUV",
  //   seats: "6+1 Seats",
  //   fuel: "Diesel",
  //   price: "₹18/KM",
  // },
  {
    id: 13,
    image: "/images/fleet/Tempo-Traveller.jpg",
    title: "Tempo Traveller",
    category: "Traveller",
    seats: "17 Seats",
    fuel: "Diesel",
    price: "On Request",
  },
  // {
  //   id: 14,
  //   image: "/images/fleet/Urbania.jpg",
  //   title: "Force Urbania",
  //   category: "Luxury Urbania",
  //   seats: "17 Seats",
  //   fuel: "Diesel",
  //   price: "On Request",
  // },
];

const CarCard = ({ car }) => {
  return (
    <div className="col-xl-4 col-lg-4 col-md-6 mb-4 text-center ">
      <div
      className="borderr"
        style={{
          background: "#fff",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
          height: "100%",
          transition: "0.3s ease",
          border: "1px solid #f1f1f1",
        }}
      >
        {/* Image */}
        <div
          style={{
            background: "#f8f9fa",
            padding: "20px",
            textAlign: "center",
          }}
          className=""
        >
          <img
            src={car.image}
            alt={car.title}
            style={{
              width: "100%",
              height: "220px",
              objectFit: "contain",
            }}
          />
        </div>

        {/* Content */}
        <div style={{ padding: "25px" }}>
          <h4
            style={{
              color: "#0B3D91",
              fontWeight: "700",
              fontSize: "24px",
              marginBottom: "8px",
            }}
          >
            {car.title}
          </h4>

          <p
            style={{
              color: "#F26A21",
              fontWeight: "600",
              marginBottom: "15px",
            }}
          >
            {car.category}
          </p>

          {/* One Line Features */}
          <div
            style={{
              marginBottom: "20px",
              color: "#666",
              fontSize: "15px",
              lineHeight: "1.8",
            }}
          >
            <i className="fas fa-users"></i> {car.seats}
            {" | "}
            <i className="fas fa-gas-pump"></i> {car.fuel}
            {" | "}
            <i className="fas fa-snowflake"></i> AC
          </div>

          {/* Price & Button */}
          <div className="d- alig align-items-center text-center ">
           

            <a
              href="/booking"
              target="_blank"
              rel="noreferrer"
              style={{
                background: "#F44308",
                color: "#fff",
                padding: "12px 24px",
                borderRadius: "6px",
                textDecoration: "none",
                fontWeight: "600",
                textTransform: "uppercase",
                fontSize: "14px",
                alignContent: "center",
              }}
            >
              Book Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const FeaturedInventory = () => {
  return (
    <section
     className="bghg"
      style={{
        // background:
        //   "linear-gradient(135deg,#f8fbff 0%,#fff7f0 100%)",
        padding: "30px 0",
      }}
    >
      <div className="container">
        {/* Heading */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <span
              style={{
                color: "#F26A21",
                fontWeight: "700",
                letterSpacing: "2px",
                textTransform: "uppercase",
              }}
            >
              Rising Cab Service Fleet
            </span>

            <h2
              style={{
                color: "#0B3D91",
                fontWeight: "800",
                marginTop: "10px",
                marginBottom: "15px",
              }}
            >
              Choose Your Perfect Ride
            </h2>

            <p style={{ color: "#666" }}>
              Explore our premium fleet of Sedans, SUVs, Innova
              Crysta, Tempo Travellers, Urbania and Mini Buses for
              Airport Transfers, Corporate Travel, Local Rides and
              Outstation Tours across Maharashtra.
            </p>
          </div>
        </div>

        {/* Fleet Cards */}
        <div className="row mt-5">
          {featuredCars.map((car) => (
            <CarCard key={car.id} car={car} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedInventory;